import type { UpgradeCodeResponse } from '@kimuno/api-sdk';
import immutable from 'object-path-immutable';

import { AsyncActionStatus } from '../actions/common.actionTypes';
import {
	FETCH_UPGRADE_CODE,
	type FetchUpgradeCodeAction,
} from '../actions/upgradeCodes.actionTypes';

type UpgradeCodeActionTypes = FetchUpgradeCodeAction;

export interface UpgradeCodeState {
	byId: {
		[upgradeCode: string]: {
			data?: UpgradeCodeResponse;
			status: AsyncActionStatus;
			error?: Error;
		};
	};
}

const initialState: UpgradeCodeState = {
	byId: {},
};

// biome-ignore lint/style/useDefaultParameterLast: parameter order is a fixed contract (Redux reducer signature / existing call sites)
const upgradeCodes = (state = initialState, action: UpgradeCodeActionTypes): UpgradeCodeState => {
	switch (action.type) {
		case FETCH_UPGRADE_CODE.START:
			return immutable(state)
				.set(['byId', action.payload.upgradeCode, 'status'], AsyncActionStatus.LOADING)
				.value();

		case FETCH_UPGRADE_CODE.SUCCESS:
			return immutable(state)
				.set(['byId', action.payload.upgradeCode], {
					status: AsyncActionStatus.READY,
					data: action.result,
					error: undefined,
				})
				.value();

		case FETCH_UPGRADE_CODE.ERROR:
			return immutable(state)
				.merge(['byId', action.payload.upgradeCode], {
					status: AsyncActionStatus.ERROR,
					error: action.error,
				})
				.value();

		default:
			return state;
	}
};

export default upgradeCodes;
